import { render } from "./TimeTableLine.vue?vue&type=template&id=b4b1c672"
import script from "./TimeTableLine.vue?vue&type=script&lang=ts"
export * from "./TimeTableLine.vue?vue&type=script&lang=ts"
script.render = render

export default script